import { render } from "./ExerciseViewer.vue?vue&type=template&id=55a75be0&ts=true"
import script from "./ExerciseViewer.vue?vue&type=script&lang=ts"
export * from "./ExerciseViewer.vue?vue&type=script&lang=ts"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__